import React from "react";
import { Typography, Grid, Box } from "@mui/material";

const FeatureCard = ({ title, highlight, description }) => (
  <Box sx={{ padding: 2 }}>
    <Typography variant="h6" component="div" gutterBottom>
      {title} <span style={{ color: "#4179E1" }}>{highlight}</span>
    </Typography>
    <Typography variant="body1" color="textSecondary">
      {description}
    </Typography>
  </Box>
);

const WhyWe = () => {
  return (
    <Box sx={{ pt: 4 }}>
      <Box sx={{ textAlign: "center", marginBottom: 4 }}>
        <Typography
          variant="h4"
          align="center"
          gutterBottom
          mb={0}
          sx={{ fontWeight: "bold" }}
        >
          Turn your business dream into reality—quick, easy, and affordable!
        </Typography>
        <Typography variant="subtitle1" color="textSecondary">
          There are numerous reasons why you want to choose us
        </Typography>
      </Box>
      <Grid container spacing={4}>
        <Grid item xs={12} md={4}>
          <FeatureCard
            title="No hidden"
            highlight="Charges"
            description="Our pricing is 100% transparent. You’ll only pay what you see, with no surprises and no hidden charges."
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <FeatureCard
            title="Company formation in"
            highlight="Hours"
            description="Our service is crafted to make the company formation process incredibly fast. In most cases, we can have your company set up within hours. We're dedicated to offering a smooth and efficient experience, so you can get your business up and running quickly and start focusing on growth."
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <FeatureCard
            title="Your Satisfaction, Our "
            highlight="Promise"
            description="When you choose to work with us, you can rest assured that your satisfaction is our highest priority. We're dedicated to delivering top-notch service, providing you with the latest information, and offering intuitive company management tools, all designed to make your experience smooth and enjoyable."
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <FeatureCard
            title="Affordable"
            highlight="Pricing"
            description="We provide a range of affordable company formation packages designed to suit your budget and specific needs. Our primary goal is to support your business's success by offering flexible pricing options that help you get started on the right foot."
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <FeatureCard
            title="Data protection and"
            highlight="Security"
            description="We place the highest importance on protecting your sensitive information, including payment details and both company and personal data. Our system is designed with the utmost care, incorporating robust security measures to ensure your information remains safe and confidential at all times."
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default WhyWe;
